<nz-spin [nzSpinning]="isLoading">
  <div *ngIf="country" class="grid grid-cols-1 mb-3">
    <div>
      <label
        class="mb-1"
        nz-checkbox
        [ngModelOptions]="{standalone: true}"
        [(ngModel)]="currentCountryBoxChecked"
        (ngModelChange)="onChangeCurrentCountry($event)"
      >{{ 'itineraries.transport.form.displayLocationsOnlyFrom' | transloco }} {{ this.country }}</label>
    </div>
  </div>
  <div class="grid grid-cols-2 gap-5">
    <!--  <div>-->
    <!--    <nz-select-->
    <!--      nzPlaceHolder="From"-->
    <!--      nzAllowClear-->
    <!--      nzShowSearch-->
    <!--      nzServerSearch-->
    <!--      [(ngModel)]="selectedTransportFrom"-->
    <!--      (nzOnSearch)="onSearchFrom($event)">-->
    <!--      <ng-container *ngFor="let option of optionListFrom">-->
    <!--        <nz-option-->
    <!--          *ngIf="!isLoading" [nzValue]="option.placePrediction"-->
    <!--          [nzLabel]="option.placePrediction.text.text"-->
    <!--          (click)="selectedDestinationFrom({id:option.placePrediction.placeId,option})">-->
    <!--        </nz-option>-->
    <!--      </ng-container>-->
    <!--      <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>-->
    <!--        <span nz-icon nzType="loading" class="loading-icon"></span>-->
    <!--        Loading Data...-->
    <!--      </nz-option>-->
    <!--    </nz-select>-->
    <!--  </div>-->
    <div>
      <nz-select
        nzShowSearch
        nzServerSearch
        [nzPlaceHolder]="'itineraries.transport.form.from' | transloco"
        [(ngModel)]="this.selectedTransportFrom"
        [nzShowArrow]="false"
        (nzOnSearch)="searchTransportFrom($event)"
        (ngModelChange)="this.selectedDestinationFrom(this.selectedTransportFrom)"
      >
        <nz-option *ngFor="let option of this.optionListFrom" [nzLabel]="option.placePrediction.text.text"
                   [nzValue]="option.placePrediction"></nz-option>
      </nz-select>
    </div>
    <div>
      <nz-select
        nzShowSearch
        nzServerSearch
        [nzPlaceHolder]="'itineraries.transport.form.to' | transloco"
        [(ngModel)]="this.selectedTransportTo"
        [nzShowArrow]="false"
        (nzOnSearch)="searchTransportTo($event)"
        (ngModelChange)="this.selectedDestinationTo(this.selectedTransportTo)"
      >
        <nz-option *ngFor="let option of this.optionListTo" [nzLabel]="option.placePrediction.text.text"
                   [nzValue]="option.placePrediction"></nz-option>
      </nz-select>
    </div>
    <!--  <div>-->
    <!--    <nz-select-->
    <!--      nzPlaceHolder="To"-->
    <!--      nzAllowClear-->
    <!--      nzShowSearch-->
    <!--      nzServerSearch-->
    <!--      [(ngModel)]="selectedTransportTo"-->
    <!--      (nzOnSearch)="onSearchTo($event)">-->
    <!--      <ng-container *ngFor="let option of optionListTo">-->
    <!--        <nz-option-->
    <!--          *ngIf="!isLoading" [nzValue]="option.placePrediction"-->
    <!--          [nzLabel]="option.placePrediction.text.text"-->
    <!--          (click)="selectedDestinationTo({id:option.placePrediction.placeId,option})">-->
    <!--        </nz-option>-->
    <!--      </ng-container>-->
    <!--      <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>-->
    <!--        <span nz-icon nzType="loading" class="loading-icon"></span>-->
    <!--        Loading Data...-->
    <!--      </nz-option>-->
    <!--    </nz-select>-->
    <!--  </div>-->
  </div>
  <nz-divider></nz-divider>
  <div class="grid grid-cols-1">
    <div class="mt-4">
      <form nzLayout="vertical" nz-form [formGroup]="transportForm">
        <div class="grid grid-cols-2 gap-5">
          <div>
            <nz-form-item>
              <nz-form-label
                nzRequired
                nzFor="selectedDate"
              >{{ 'itineraries.transport.form.date' | transloco }}
              </nz-form-label
              >
              <nz-form-control [nzErrorTip]="selectedDateCheck">
                <nz-select
                  formControlName="selectedDate"
                  [nzPlaceHolder]="'itineraries.transport.form.selectDate' | transloco"
                  (ngModelChange)="setSelectedIndex($event)">
                  <nz-option *ngFor="let day of this.itinerary.days; let i =index " [nzValue]="day.date"
                             [nzLabel]="!itinerary.tour.isDatesOptional ?
                             'Day ' + (i + 1) + ' - ' + (day.date | date:'dd/MM/yyyy'): 'Day ' + (i + 1)">
                  </nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #selectedDateCheck>
            <span *ngIf="formErrors.selectedDate.required">
              {{ 'itineraries.transport.form.errors.dateRequired' | transloco }}
            </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div>
            <nz-form-item>
              <nz-form-label
                nzRequired
                nzFor="typeOfVehicle"
              >{{ 'itineraries.transport.form.modeOfTravel' | transloco }}
              </nz-form-label
              >
              <nz-form-control [nzErrorTip]="typeOfVehicleCheck">
                <nz-select
                  formControlName="typeOfVehicle"
                  [nzPlaceHolder]="'itineraries.transport.form.selectOption' | transloco">
                  <nz-option *ngFor="let transport  of transportTypes" [nzValue]='transport.value'
                             [nzLabel]="transport.label"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #typeOfVehicleCheck>
            <span *ngIf="formErrors.typeOfVehicle.required">
              {{ 'itineraries.transport.form.errors.typeOfVehicleRequired' | transloco }}
            </span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
        <div>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="mileage">{{ 'itineraries.transport.form.mileage' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="mileageCheck">
              <nz-input-group nzSearch class="py-0 pr-0">
                <nz-input-number
                  style="width: 70%"
                  [nzMin]="0"
                  class="mr-1"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="mileage"></nz-input-number>
                <nz-select formControlName="mileageUnit" style="width: 29.25%">
                  <nz-option *ngFor="let op of mileageUnitOptions" [nzValue]="op.value"
                             [nzLabel]="op.label"></nz-option>
                </nz-select>
              </nz-input-group>
            </nz-form-control>
            <ng-template #mileageCheck>
            <span *ngIf="formErrors.mileage.required">
              {{ 'itineraries.transport.form.errors.mileageRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control>
            <label
              class="mb-1"
              nz-checkbox
              formControlName="isMileageAuto"
            >{{ 'itineraries.transport.form.autoMileage' | transloco }}</label>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="mt-3 flex flex-row items-start justify-between">
          <div class="flex items-center gap-5 mt-2 " *ngIf="
            this.transportForm.controls.typeOfVehicle.value === 'land' &&
            filteredTransportValues.length > 0 || filteredAltTransportValues.length > 0 ">
            <h5 class="font-bold">{{ 'itineraries.transport.form.vehicleSelection' | transloco }}</h5>
            <ng-container *appHasAnyPrivilege="'RATES.TRANSPORT.VIEW'">
              <lucide-icon
                [routerLink]="['/admin/rates/transport-config']"
                (click)="this.handleCancel()"
                name="cog"
                class="w-6 h-6 text-[#7C3AED] hover:cursor-pointer"></lucide-icon>
            </ng-container>
          </div>
          <nz-form-item class="flex  flex-row justify-end gap-2 m-0" style="flex-direction: row">
            <nz-form-label class="mt-2" nzFor="costingCurrency">{{ 'itineraries.transport.form.costingCurrency' | transloco }} :</nz-form-label>
            <div class="w-24">
              <nz-select [(ngModel)]="this.isPrimaryCurrency" (ngModelChange)="this.onChangeCurrency($event)" [ngModelOptions]="{standalone: true}">
                <nz-option
                  *ngFor="let lang of this.currencies"
                  [nzValue]="lang?.value"
                  [nzLabel]="lang?.label"></nz-option>
              </nz-select>
            </div>
          </nz-form-item>
        </div>
        <div class="grid grid-cols-12 gap-5 my-4" *ngIf="
          this.transportForm.controls.typeOfVehicle.value === 'land' ">
          <div class="col-span-8 space-y-4">
            <div *ngIf="filteredTransportValues?.length !==  0">
              <p>{{ 'itineraries.transport.form.recommendedVehicles' | transloco }}</p>
              <ng-container>
                <div class="inline-flex items-center gap-3 ml-3 flex-nowrap">
                  <nz-tag [nzColor]="'purple'"
                    *ngFor="let val of filteredTransportValues"
                    class=" hover:cursor-pointer mt-2" (click)="this.onClickPopulate(val)">
                    {{ val.vehicleType }} - {{ val.costPerMileage | number:'1.2-2' }}
                  </nz-tag>
                </div>
              </ng-container>
            </div>
            <div *ngIf="filteredAltTransportValues.length  !== 0">
              <h5> {{filteredTransportValues.length > 0 ? (('itineraries.transport.form.additional' | transloco) + ' ') : ''}}{{ 'itineraries.transport.form.vehicleOptions' | transloco }}</h5>
              <ng-container>
                <div class="inline-flex items-center gap-3 ml-3 flex-nowrap">
                  <nz-tag [nzColor]="'purple'"
                    *ngFor="let val of filteredAltTransportValues"
                    class=" hover:cursor-pointer mt-2" (click)="this.onClickPopulate(val)">
                    {{ val.vehicleType }} - {{ val.costPerMileage | number:'1.2-2' }}
                  </nz-tag>
                </div>
              </ng-container>
            </div>

            <button
              *ngIf="filteredTransportValues.length > 0 || filteredAltTransportValues.length > 0"
              nz-button
              nzType="default"
              type="button"
              (click)="this.onClickClear()">
                {{ 'itineraries.transport.form.clearSelection' | transloco }}
            </button>
          </div>
          <div class="col-span-4 gap-3 text-center space-y-4"
            *ngIf="filteredTransportValues.length > 0 || filteredAltTransportValues.length > 0">
            <nz-tag [nzColor]="'purple'">
              {{this.transportForm.get('transVehicleConfig')?.value}}
            </nz-tag>
            <img [src]="this.transportForm.get('vehicleImage')?.value !== '' ?
              this.transportForm.get('vehicleImage').value :
              'assets/img/placeholder-image.png'"
              [attr.alt]="'itineraries.transport.form.vehicleImageAlt' | transloco"
              class="w-full h-44 rounded-lg object-cover mx-auto">
              <h5 class="text-center">{{ 'itineraries.transport.form.vehiclePreview' | transloco }}</h5>
          </div>
        </div>
        <div *ngIf="this.transportForm.controls.typeOfVehicle.value === 'land'">
          <nz-form-item>
            <nz-form-label class="mt-2" [nzSm]="6" [nzXs]="24" nzFor="costPerMileage">{{ 'itineraries.transport.form.costPerMileage' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="costPerMileageCheck">
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="costPerMileage">
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
            <ng-template #costPerMileageCheck>
            <span *ngIf="formErrors.costPerMileage.required">
              {{ 'itineraries.transport.form.errors.costPerMileageRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>
        </div>
        <div *ngIf="this.transportForm.controls.typeOfVehicle.value === 'land'">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="driverBata">{{ 'itineraries.transport.form.driverBata' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="driverBataCheck">
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="driverBata">
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
            <ng-template #driverBataCheck>
            <span *ngIf="formErrors.driverBata.required">
              {{ 'itineraries.transport.form.errors.driverBataRequired' | transloco }}
            </span>
            </ng-template>
          </nz-form-item>
        </div>
        <div *ngIf="this.transportForm.controls.typeOfVehicle.value !== 'land'">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="costPerAdult">{{ 'itineraries.transport.form.costPerAdult' | transloco }}</nz-form-label>
            <nz-form-control>
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="perAdult">
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="this.transportForm.controls.typeOfVehicle.value !== 'land'">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="costPerChild">{{ 'itineraries.transport.form.costPerChild' | transloco }}</nz-form-label>
            <nz-form-control>
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="perChild">
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="this.transportForm.controls.typeOfVehicle.value !== 'land'">
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="costPerInfant">{{ 'itineraries.transport.form.costPerInfant' | transloco }}</nz-form-label>
            <nz-form-control>
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="perInfant">
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div>
          <nz-form-item>
            <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="totalCost">{{ 'itineraries.transport.form.totalCost' | transloco }}</nz-form-label>
            <nz-form-control [nzErrorTip]="costCheck">
              <nz-input-group nzSearch [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                <nz-input-number
                  [nzFormatter]="formatter"
                  [nzParser]="parser"
                  [nzPrecision]="2"
                  [nzStep]="0.01"
                  nzDisabled
                  class="w-full border-none"
                  [nzMin]="0"
                  [nzPlaceHolder]="'common.amount' | transloco"
                  formControlName="totalCost"
                >
                </nz-input-number>
              </nz-input-group>
              <ng-template #prefixCurrency>{{
                  this.isPrimaryCurrency ?  this.itinerary.tour.currency : this.itinerary.tour.secondaryCurrency | uppercase
                }}
              </ng-template>
            </nz-form-control>
            <ng-template #costCheck>
            <span *ngIf="formErrors.cost.required">
              {{ 'itineraries.transport.form.errors.costRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item>
          <nz-form-label [nzSm]="30" [nzXs]="30" nzRequired nzFor="time">{{ 'itineraries.transport.form.approximateTravelTime' | transloco }}</nz-form-label>
          <div class="grid grid-cols-2 gap-5">
            <nz-form-control [nzErrorTip]="hoursCheck">
              <nz-input-group [nzSuffix]="suffixHoursText">
                <input type="number" formControlName="hours" [placeholder]="'itineraries.transport.form.enterApproximateHour' | transloco" nz-input/>
              </nz-input-group>
              <ng-template #suffixHoursText>
                {{ 'itineraries.transport.form.hours' | transloco }}
              </ng-template>
            </nz-form-control>
            <ng-template #hoursCheck>
              <span *ngIf="formErrors.hours.required">
                {{ 'itineraries.transport.form.errors.hoursRequired' | transloco }}
              </span>
            </ng-template>

            <nz-form-control [nzErrorTip]="mintuesCheck">
              <nz-input-group [nzSuffix]="suffixMinutesText">
                <input type="number" formControlName="minutes" [placeholder]="'itineraries.transport.form.enterApproximateMinutes' | transloco" nz-input/>
              </nz-input-group>
              <ng-template #suffixMinutesText>
                {{ 'itineraries.transport.form.minutes' | transloco }}
              </ng-template>
            </nz-form-control>
            <ng-template #mintuesCheck>
              <span *ngIf="formErrors.mintues.required">
                {{ 'itineraries.transport.form.errors.minutesRequired' | transloco }}
              </span>
            </ng-template>
          </div>
        </nz-form-item>
      </div>
      <div>
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="notes">{{ 'itineraries.transport.form.notes' | transloco }}</nz-form-label>
          <nz-form-control>
                  <textarea
                    nz-input
                    [placeholder]="'itineraries.transport.form.notesPlaceholder' | transloco"
                    formControlName="notes"
                    rows="6"></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.transport.form.close' | transloco }}</button>
    <button *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.NEW" nz-button nzType="primary"
            (click)="addTransport()"
            [nzLoading]="this.isButtonLoading"
            [disabled]="!this.transportForm.valid || this.selectedTransportFrom === undefined  || this.selectedTransportTo === undefined"
    >{{ 'itineraries.transport.form.add' | transloco }}
    </button>
    <button *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT" nz-button nzType="primary"
            (click)="editTransport()"
            [nzLoading]="this.isButtonLoading"
            [disabled]="!this.transportForm.valid "
    >{{ 'itineraries.transport.form.edit' | transloco }}
    </button>
  </div>
</nz-spin>
